import { BookingsSummaryReport } from 'model/BookingsReport';
import { Action } from 'redux';

//Action Types
export const BOOKINGS_SUMMARY_REPORT_GET_START = 'BOOKINGS_SUMMARY_REPORT_GET_START';
export const BOOKINGS_SUMMARY_REPORT_GET_SUCCESS = 'BOOKINGS_SUMMARY_REPORT_GET_SUCCESS';
export const BOOKINGS_SUMMARY_REPORT_GET_ERROR = 'BOOKINGS_SUMMARY_REPORT_GET_ERROR';

//Actions
type BookingsSummaryReportGetStartAction = Action<typeof BOOKINGS_SUMMARY_REPORT_GET_START>;

interface BookingsSummaryReportGetSuccessAction extends Action<typeof BOOKINGS_SUMMARY_REPORT_GET_SUCCESS> {
    payload: {
        summary: BookingsSummaryReport;
    };
}

type BookingsSummaryReportErrorAction = Action<typeof BOOKINGS_SUMMARY_REPORT_GET_ERROR>;

export type BookingsSummaryReportAction =
    | BookingsSummaryReportGetStartAction
    | BookingsSummaryReportGetSuccessAction
    | BookingsSummaryReportErrorAction;
